import brand from '@helpers/brand';
import { Grid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import lines from '@img/icons/lines.svg';
import { m } from 'framer-motion';
import styled from 'styled-components';
const MotionWrapper = styled(m.div).attrs((props) => ({
    initial: 'hidden',
    animate: props['data-in-view'] ? 'visible' : 'hidden',
})) `
  display: contents;
`;
const Container = styled.div `
  position: relative;
  margin: 40px 0px;

  @media ${from(Device.Tablet)} {
    margin: 80px 0px;
  }

  @media ${from(Device.Desktop)} {
    margin: 96px 0px;
  }

  [data-in-view='true'] & {
    &:before {
      opacity: 1;
    }
  }

  &:before {
    content: '';
    position: absolute;

    transform: translateY(-50%) skewY(-5deg);
    height: 115px;
    width: 100%;
    z-index: 0;
    background: url(${lines});
    background-size: 500px;
    background-repeat: no-repeat;
    top: 52%;
    left: 2%;

    opacity: 0;
    transition: opacity 0.75s;

    @media ${from(Device.TabletLarge)} {
      top: 59%;
      left: 4%;
    }
  }
`;
const BackgroundEffect = styled(m.div).attrs(() => ({
    variants: {
        initial: {
            height: '0px',
        },
        visible: {
            height: '115px',
            transition: {
                duration: 0.75,
            },
        },
    },
})) `
  position: absolute;
  top: 50%;
  transform: translateY(-50%) skewY(-5deg);
  width: 100%;
  background-color: ${brand.primary.alt};
  z-index: 0;
`;
const CardGrid = styled(Grid.Default) `
  position: relative;
  z-index: 1;

  ${() => CardWrapper} {
    grid-column: span 12;

    @media ${from(Device.TabletLarge)} {
      grid-column: span 4;
    }
  }
`;
const CardWrapper = styled(m.div).attrs((props) => ({
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.75, delay: 0.2 * props['data-offset'] },
})) ``;
export const PromoCardsStyles = {
    Container,
    CardGrid,
    MotionWrapper,
    CardWrapper,
    BackgroundEffect,
};
